import { appConfig } from "./app.config";
import { apiConfig } from "./api.config";
import { integrationConfig } from "./integration.config";
import { assetConfig } from "./asset.config";
import { domainConfig } from "./domain.config";

export const config = Object.freeze({
  app: appConfig,
  api: apiConfig,
  integration: integrationConfig,
  assets: assetConfig,
  domains: domainConfig,
});